<template>
  <div class="Users">
    <app-header></app-header>

    <el-container style="border: 1px solid #eee">
      <app-sidebar></app-sidebar>
      <el-main>
        <app-breadcrumb></app-breadcrumb>
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column fixed prop="account" label="账号" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width>
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" disabled>编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                disabled
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页栏 -->
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="20"
          ></el-pagination>
        </div>
        <!-- 分页栏 -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Users',
  data() {
    const item = {
      account: 'admin'
    }
    return {
      tableData: Array(1).fill(item),
      currentPage4: 1
    }
  },
  methods: {
    handleEdit(index, row) {
      console.log(index, row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style scoped>
.el-table {
  margin-top: 30px;
}
.el-pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
